import { motion } from "framer-motion";

const stats = [
  { number: "25+", label: "Anos de experiencia" },
  { number: "500k+", label: "Pasajeros transportados" },
  { number: "200+", label: "Viajes al ano" },
];

export default function Hero() {
  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center overflow-hidden pt-24 md:pt-0 pb-16 md:pb-0"
      data-testid="hero-section"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/assets/foto-hero.png"
          alt="Bus Puerto Deseado en montana"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Dark overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0D1525] via-[#0D1525]/85 to-transparent z-10" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D1525] via-transparent to-transparent z-10" />

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 md:px-12 w-full">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
          <span className="inline-block text-[#3DD9E8] text-sm font-bold uppercase tracking-[0.3em] mb-6 font-body">
            Transporte de pasajeros
          </span>
          <h1 className="font-heading text-6xl sm:text-7xl md:text-8xl lg:text-9xl text-white leading-[0.85] mb-6">
            VIAJA CON<br />
            <span className="text-[#D0162A]">CONFIANZA</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-300 font-body font-light max-w-xl mb-10 leading-relaxed">
            Mas de dos decadas y media conectando destinos con seguridad, confort y servicio de primera clase.
          </p>

          {/* Buttons */}
          <div className="flex flex-wrap gap-4 mb-16">
            <a
              href="#contacto"
              className="clip-slant bg-[#D0162A] hover:bg-[#b01020] text-white font-bold uppercase tracking-wider py-4 px-10 text-sm transition-colors duration-200 hover:-translate-y-1 inline-block"
              style={{ transition: "background-color 0.2s, transform 0.2s" }}
              data-testid="hero-cta-primary"
            >
              Solicitar Presupuesto
            </a>
            <a
              href="#flota"
              className="clip-slant border-2 border-white/30 hover:bg-white/5 text-white font-bold uppercase tracking-wider py-4 px-10 text-sm transition-colors duration-200 inline-block"
              data-testid="hero-cta-secondary"
            >
              Conocer Flota
            </a>
          </div>
        </motion.div>

        {/* Stats row */}
        <motion.div
          className="flex flex-wrap gap-8 md:gap-16 border-t border-white/10 pt-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {stats.map((stat) => (
            <div key={stat.label} data-testid={`hero-stat-${stat.number}`}>
              <span className="font-heading text-4xl md:text-5xl text-[#3DD9E8]">
                {stat.number}
              </span>
              <p className="text-xs uppercase tracking-[0.2em] text-gray-400 font-body font-bold mt-1">
                {stat.label}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
